// extracted by mini-css-extract-plugin
module.exports = {"addpost_label":"FormLabels_addpost_label__vvaAK"};